var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"svgimg",class:{ 'prevent_dark_invert': _vm.prevent_invert },attrs:{"src":'/assets/svg/' + _vm.name + '.svg'},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }